import { HasValue, merge, validator } from '@ally/validator';
import { NotSameAccountValidator, NotBothExternalAccountsValidator, } from '../shared';
export var HasValueError = 'Please select a from account.';
export default merge(
// Required
validator(HasValue, HasValueError), 
// Not same as To Account
NotSameAccountValidator, 
// Not both external accounts
NotBothExternalAccountsValidator);
//# sourceMappingURL=validator.js.map